import { connect } from 'react-redux';
import get from 'lodash/get';
import WorksComponent from './WorksComponent';

const mapStateToProps = (state, ownProps) => {
	const entry = get( state.fetcher, ['archives', 'all'] );
	const status = entry ? entry.status : null;
	const items = get( entry, ['data'], [] );
	return {
		loaded: (status === 'success' || status === 'error'),
		items: (items.length > 0)? items : null,
		breadcrumb: [{title: 'All works'}]
	}
}

export default connect(mapStateToProps)(WorksComponent);


// WEBPACK FOOTER //
// ./src/components/Pages/Works/Works.jsx